export enum SubmissionStage {
  Idle = "idle",
  Uploading = "uploading",
  Analyzing = "analyzing",
  Preparing = "preparing",
  Generating = "generating",
  Complete = "complete",
  Error = "error",
}
